import { defineSlotRecipe } from "@pandacss/dev";

export const slots = ["container", "wrap", "title", "innerWrap"];

export const aromaSectionHeader = defineSlotRecipe({
  className: "aroma-section-header",
  jsx: [
    "SectionHeader",
    "SectionContainer",
    "SectionWrap",
    "SectionInnerWrap",
    "AromaSectionHeaderLayout",
  ],
  slots,
  base: {
    container: {
      width: "100%",
      paddingY: "padding.2",
      justifyContent: "space-between",
      gap: "gap.2",
      backgroundColor: "background.neutral.base.subtlest",
      borderBottomRightRadius: "2xl",
      shadow: "effect.shadow.subtle-bottom",
      sm: {
        paddingY: "padding.3",
      },
    },
    wrap: {
      width: "100%",
      maxWidth: "width.4xl",
      margin: "auto",
      flexWrap: "wrap",
      justifyContent: "space-between",
      paddingInline: "padding.2",
      gap: "gap.1",
      sm: {
        paddingInline: "padding.3",
      },
      xs: {
        gap: "gap.2",
      },
    },
    innerWrap: {
      alignItems: "center",
      gap: "gap.1",
      xs: {
        gap: "gap.2",
      },
    },
    title: {
      textStyle: "title.m",
      paddingLeft: "padding.2",
      sm: {
        textStyle: "title.l",
        paddingLeft: "padding.3",
      },
      lg: {
        textStyle: "title.xl",
      },
    },
  },
  variants: {
    fullWidth: {
      true: {
        wrap: {
          maxWidth: "100%",
        },
      },
      false: {},
    },
  },
  defaultVariants: {
    fullWidth: false,
  },
});
